import type { BulkTags } from '../types'

export function updateTagsWarning(tagsIn: BulkTags, tagsOut: BulkTags) {
  updateWarningForBulkTags(tagsIn, tagsOut)
  updateWarningForBulkTags(tagsOut, tagsIn)
}

function updateWarningForBulkTags(tagsToUpdate: BulkTags, tagsToCompare: BulkTags) {
  for (const tagName of Object.keys(tagsToUpdate.tags)) {
    const tag = tagsToUpdate.tags[tagName]
    if (tag.status === 'deleted') continue

    const compareTag = tagsToCompare.tags[tagName]
    const hasCollision = compareTag?.status === 'exact' || compareTag?.status === 'partial'

    if (tag.status === 'partial' || tag.status === 'exact') {
      tag.warning = hasCollision
    }
  }
}
